import { render, staticRenderFns } from "./ValidatedDiagnosticIssues.vue?vue&type=template&id=2b9633a7&scoped=true"
import script from "./ValidatedDiagnosticIssues.vue?vue&type=script&lang=js"
export * from "./ValidatedDiagnosticIssues.vue?vue&type=script&lang=js"
import style0 from "./ValidatedDiagnosticIssues.vue?vue&type=style&index=0&id=2b9633a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9633a7",
  null
  
)

export default component.exports